var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./visual-type-accordions-Keith.vue?vue&type=custom&index=0&blockType=h4&class=text-sm%20font-bold%20p-0"
if (typeof block0 === 'function') block0(component)
import block1 from "./visual-type-accordions-Keith.vue?vue&type=custom&index=1&blockType=div&v-for=(behavior%2C%20index)%20in%20behaviors&class=mb-4"
if (typeof block1 === 'function') block1(component)

export default component.exports